import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/styles";
import API from "../../actions";
import Copyright from "./Copyright";
import styles from "./styles";
import queryString from "query-string";

const useStyles = makeStyles(styles);

const ResetPassword = props => {
    const classes = useStyles();
    const token = queryString.parse(props.location.search).token;
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Nyt password
                    </Typography>
                    <form
                        className={classes.form}
                        onSubmit={async event => {
                            event.preventDefault();
                            if (password !== passwordConfirm) return window.alert("Passwords er ikke ens");
                            localStorage.setItem("token", token);
                            await API.setPassword("", password);
                            localStorage.setItem("token", "");
                            window.alert("Password opdateret");
                            window.location.replace("/");
                        }}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Nyt password"
                            type="password"
                            value={password}
                            onChange={event => setPassword(event.target.value)}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Nyt password (gentag)"
                            type="password"
                            value={passwordConfirm}
                            onChange={event => setPasswordConfirm(event.target.value)}
                        />

                        <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                            Bekræft
                        </Button>
                        <Box mt={5}>
                            <Copyright />
                        </Box>
                    </form>
                </div>
            </Grid>
        </Grid>
    );
};

export default ResetPassword;
